// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
import * as React from 'react';
import { TextArea } from '@ta/input.text-area';
import Localize, { UnsafeLocalize } from '@ta/platform.i18n';
import styles from './CommentBox.css';

type Props = {|
  required: boolean,
  minLength: number,
  maxLength: number,
  label?: React.Node,
  value: string,
  onChange?: (SyntheticKeyboardEvent<HTMLTextAreaElement>) => void,
  className: ?string,
|};

const getNumberLabelsOrNull = (required: boolean, minLength: number, maxLength: number) => {
  if (!required) {
    return null;
  }

  return (
    <div className={styles.numberLabels}>
      <Localize id="ur_rd_0characterminimum" args={{ '0': minLength }} />
      &nbsp;/&nbsp;
      <Localize id="ur_rd_0charactermaximum" args={{ '0': maxLength }} />
    </div>
  );
};

const CommentBox = (props: Props) => {
  let textLabel = props.label;
  if (!textLabel) {
    textLabel = props.required ? (
      <Localize id="social_report_level2_6b" />
    ) : (
      <UnsafeLocalize id="social_report_level2_5" />
    );
  }

  const numberLabels = getNumberLabelsOrNull(props.required, props.minLength, props.maxLength);

  return (
    <div className={props.className}>
      <div className={styles.textLabel}>{textLabel}</div>
      <TextArea
        className={styles.commentBox}
        value={props.value}
        onChange={props.onChange}
        maxLength={props.maxLength}
      />
      {numberLabels}
    </div>
  );
};

CommentBox.defaultProps = {
  required: false,
  label: '',
  minLength: 10,
  maxLength: 250,
  className: null,
};

export default CommentBox;
